export default __webpack_public_path__ + "static/media/eden.510c7e92.svg";